import { FileReadingComponent } from './containers/file-reading/file-reading.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CartSuggestionGuard } from '../core/guards/cart-suggestion.guard';
import {
  NewCreditCardDialogEntryComponent,
} from '../credit-card/containers/new-credit-card-dialog-entry/new-credit-card-dialog-entry.component';
import { DemoGuard } from '../demo/demo.guard';
import { LastPaymentEntryComponent } from '../pay/containers/last-payment-entry/last-payment-entry.component';
import { PayComponent } from '../pay/containers/pay/pay.component';
import {
  PaymentDetailsNotConsistentDialogEntryComponent,
} from '../pay/containers/payment-details-not-consistent-dialog-entry/payment-details-not-consistent-dialog-entry.component';
import {
  OfferDetailsDialogEntryComponent,
} from '../shared-dialogs/containers/offer-details-entry/offer-details-dialog-entry.component';
import {
  AddLiabilityManualContainerComponent,
} from './containers/add-liability-manual-container/add-liability-manual-container.component';
import { AddLiabilityScanComponent } from './containers/add-liability-scan/add-liability-scan.component';
import { AddLiabilityComponent } from './containers/add-liability/add-liability.component';
import { LiabilityDelagateComponent } from './containers/liability-delagate/liability-delagate.component';
import { LiabilityDetailsComponent } from './containers/liability-details/liability-details.component';
import { LiabilityListComponent } from './containers/liability-list/liability-list.component';
import {
  OtherPaymentInfoDialogEntryComponent,
} from './containers/other-payment-info-dialog-entry/other-payment-info-dialog-entry.component';
import { OcrEnabledGuard } from './guards/ocr-enabled-verification.guard';
import {
  LiabilityScanCompletedComponent,
} from './containers/liability-scan-completed/liability-scan-completed.component';
import {
  LiabilityDataConfirmationComponent,
} from './containers/liability-data-confirmation/liability-data-confirmation.component';
import { AddLiabilityEmailComponent } from './containers/add-liability-email/add-liability-email.component';
import { AutomaticReadingResultDataResolver } from './resolvers/AutomaticReadingResultDataResolver';
import { CustomerBillerResolver } from '../billers/resolvers/customerbiller.resolver';
import { PayGuard } from '../pay/guards/pay.guard';
import { LiabilityVerificationResolver } from './resolvers/LiabilityVerificationResolver';
import { UrgentRedirectGuard } from '../core/guards/urgent-redirect.guard';

export const liabilitiesRoutes: Routes = [
  {
    canActivate: [CartSuggestionGuard],
    path: 'liabilities',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'all',
      },
      {
        path: 'urgent',
        canActivate: [UrgentRedirectGuard],
        component: LiabilityListComponent,
      },
      {
        path: '',
        children: [
          {
            component: LiabilityListComponent,
            path: 'all',
            data: {
              toolbar: {
                search: true,
                searchPlaceholder: 'Wyszukaj Opłaty',
                tagFilter: true,
                title: 'Twoje wydatki',
              },
            },
            children: [
              {
                component: OfferDetailsDialogEntryComponent,
                path: 'offer',
              },
            ],
          },
          {
            component: LastPaymentEntryComponent,
            path: 'last-payment',
          },
          {
            component: AddLiabilityComponent,
            path: 'add',
            data: {
              toolbar: {
                title: 'Dodaj nowy',
                prevPath: '/liabilities',
              },
            },
          },
          {
            component: AddLiabilityManualContainerComponent,
            path: 'add/manual',
            resolve: {
              customerBiller: CustomerBillerResolver,
            },
            data: {
              toolbar: {
                title: 'Dodaj nowy',
                prevPath: '/liabilities/add',
              },
            },
          },
          {
            component: AddLiabilityEmailComponent,
            path: 'add/email',
            data: {
              toolbar: {
                title: 'Przekaż fakturę',
                prevPath: '/liabilities/email',
              },
            },
          },
          {
            component: AddLiabilityScanComponent,
            canActivate: [OcrEnabledGuard],
            path: 'add/scan',
            data: {
              toolbar: {
                title: 'Dodaj nowy',
              },
            },
          },
          {
            path: 'add/top-up',
            loadChildren: () => import('../topup/topup.module').then((m) => m.TopUpModule),
          },
          {
            component: FileReadingComponent,
            path: 'reading/:id',
            data: {
              toolbar: {
                title: 'Odczytywanie',
              },
            },
          },
          {
            component: LiabilityScanCompletedComponent,
            path: 'scan-completed/:id',
            data: {
              toolbar: {
                title: 'Gotowe',
              },
            },
            resolve: {
              verified: LiabilityVerificationResolver,
            },
          },
          {
            component: LiabilityDataConfirmationComponent,
            path: 'data-confirmation/:id',
            data: {
              toolbar: {
                title: 'Prześlij dane',
              },
            },
            resolve: {
              automaticReadingResult: AutomaticReadingResultDataResolver,
            },
          },
        ],
      },

      { path: 'pay', redirectTo: 'pay/', pathMatch: 'full' },
      {
        canActivate: [DemoGuard, PayGuard],
        component: PayComponent,
        path: 'pay/:id',
        data: {
          toolbar: {
            title: 'Koszyk płatności',
          },
        },
        children: [
          {
            component: NewCreditCardDialogEntryComponent,
            path: 'newCreditCard',
          },
          {
            component: PaymentDetailsNotConsistentDialogEntryComponent,
            path: 'paymentDetailsNotConsistent',
          },
        ],
      },
      {
        path: 'pay/:id/defer',
        canActivate: [DemoGuard, PayGuard],
        loadChildren: () => import('../defer/defer.module').then((m) => m.DeferModule),
      },
      {
        path: 'data-confirmation',
        redirectTo: '/liabilities/add',
        pathMatch: 'full',
      },
      {
        canActivate: [DemoGuard],
        component: LiabilityDetailsComponent,
        path: ':id',
        data: {
          toolbar: {
            title: 'Szczegóły opłaty',
          },
        },
        children: [
          {
            component: OtherPaymentInfoDialogEntryComponent,
            path: 'otherPaymentInfo',
          },
        ],
      },
      {
        component: LiabilityDelagateComponent,
        path: ':id/delegate',
        data: {
          toolbar: {
            title: 'Przekaż do opłacenia',
          },
        },
      },
    ],
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule],
})
export class LiabilitiesRoutingModule {
}
